import TableVM from 'libs/table';
export default function (data) {
  var self = this;
  self.newRender = ko.observable(true);
  self.$window = $(window);
  self.windowWidth = ko.observable(self.$window.width());
  self.mobileBreakPoint = Kadenze.UIUtil.mobileBreakPoint();
  self.table = ko.observable();
  self.allResources = ko.observableArray();
  self.resources = ko.observableArray();
  self.courseworks = ko.observableArray();
  self.sessions = ko.observableArray();
  self.grid_view = ko.observable(true);
  self.table_view = ko.observable(false);
  self.search_view = ko.observable(false);
  self.searchApplied = ko.observable(false);
  self.searchQuery = ko.observable('');
  self.general_filter = ko.observable(false);
  self.selectedFilter = ko.observable();
  self.selectedType = ko.observable('All Types');
  self.$mobileSearchEl = $('#resources_mobile_search');
  self.$searchEl = $('#resources_search');
  self.mobile_modal = ko.observable(false);
  self.$filterModal = $('#mobile_modal_filter');
  self.$overflowModal = $('#mobile_modal_overflow');
  self.$filterTypesModal = $('#mobile_modal_type_filter');
  self.$sortOptionsModal = $('#mobile_modal_sort');
  self.typeItems = ko.observableArray();
  self.sortItems = ko.observableArray([
    { id: 1, name: 'Alphabetical', param: 'name' },
    { id: 2, name: 'Date Created', param: 'created_at' }
  ]);
  self.selectedSort = ko.observable(self.sortItems()[1]);
  self.selectedSortDir = ko.observable('desc');
  self.filterItems = ko.observableArray([
    { name: 'Courseworks' },
    { name: 'Sessions' }
  ]);
  self.acceptedURLParams = ko.observableArray([
    'q', 'filter', 'sort', 'number', 'id'
  ]);
  self.resourceSearch = {};

  self.bindData = function(data) {
    self.resources(data.resources);
    self.allResources(data.resources);
    self.courseworks(data.courseworks);
    self.sessions(data.lectures);
    var general_state = _.some(data.resources, function(r) {
      return _.some(r.all_resourcings, function(res) {
        return res.type == 'Course'; });
    });
    self.general_filter(general_state);
    var resourcesWithType = _.filter(data.resources, function(r) { return r.type; });
    self.typeItems(_.uniq(_.pluck(resourcesWithType, 'type')));
  };

  self.resourceCardData = function(resource){
    var resource_mapping = {
      'ignore': ['file_template']
    };
    return ko.mapping.toJS(resource, resource_mapping);
  };

  self.initUI = function(){
    console.log('initUI called for Kadenze.StudentResourceIndex');
    if(self.newRender()){
      self.updateFiltersFromUrl();
      Kadenze.UIUtil.hideLoadingIndicator();
      self.newRender(false);
    }
  };

  self.initMobileUI = function(){
    console.log('initMobileUI called for Kadenze.StudentResourceIndex');
    self.toggleMobileFilterBar();
    if(self.newRender()){
      self.updateFiltersFromUrl();
      Kadenze.UIUtil.hideLoadingIndicator();
      self.newRender(false);
    }
  };

  self.initTable = function() {
    var params = {
      dataset_name: 'resources',
      functions: {
        'hideResourceInfoModal': self.hideResourceInfoModal,
        'showResourceInfoModal': self.showResourceInfoModal,
        'showResourceShareModal': self.showResourceShareModal
      }
    };
    var el = document.getElementById('resource-table');
    self.table(new TableVM(data, el, params));
    ko.applyBindingsWithValidation(self.table(), el, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  };

  self.initSearchEvents = function(element) {
    element.on('blur', function () {
      if(element.val() === ''){
        self.search_view(false);
        self.updateResourceData(self.allResources());
      }
    });
  };

  // TODO: Update the local data when resources() changes.. trying not to
  // reinit on subscription, there has to be a callback to update the local data
  self.initTypeahead = function(element) {
    self.resourceSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name', 'description', 'type'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      identify: function(obj) { return obj.id; },
      limit: 20,
      local: self.resources()
    });

    self.resourceSearch.initialize();

    // if(element.hasClass('tt-input')) {
    //   element.typeahead('destroy');
    // }

    element.typeahead({
      hint: false,
      highlight: true,
      minLength: 0
    },
    {
      displayKey: 'name',
      source: self.resourceSearch.ttAdapter(),
      templates: {
        empty: [
          '<div class="empty-message">',
          'No resource with that name or description found',
          '</div>'
        ].join('\n')
      }
    });

    // For specific selecting
    element.on('typeahead:selected', function(obj, datum) {
      window.location = datum.path;
    });
  };

  self.initMobileNav = function() {
    var $mainNav = $('#main-nav');
    $mainNav = $mainNav.toggleClass('mobile-filter-bar');
  };

  self.stateChanged = function(value, type){
    if(type == 'Search'){
      self.searchChanged(value);
    } else if (type == 'Filter'){
      self.filterChanged();
    } else if (type == 'Type'){
      self.typeChanged();
    } else {
      self.sortChanged();
    }
  };

  self.updateResourceData = function(resource_data){
    if(self.grid_view()){
      self.resources(resource_data);
    } else {
      self.table().table_data(resource_data);
    }
  };

  self.toggleMobileFilterBar = function() {
    var $mainNav = $('#main-nav');
    $mainNav = $mainNav.toggleClass('mobile-filter-bar');
  };

  self.toggleView = function() {
    if(self.grid_view()) {
      self.table_view(true);
      self.grid_view(false);
      self.updateResourceData(self.resources());
    } else {
      self.grid_view(true);
      self.table_view(false);
      self.updateResourceData(self.table().table_data());
    }
  };

  self.toggleSearch = function(){
    if(self.search_view()){
      self.search_view(false);
    } else {
      self.search_view(true);
      if(self.windowWidth() < self.mobileBreakPoint){
        self.$mobileSearchEl.focus();
      } else {
        self.$searchEl.focus();
      }
    }
  };

  self.toggleFilterModal = function() {
    if(self.mobile_modal()){
      self.$filterModal.modal('hide');
      self.mobile_modal(false);
    } else {
      self.$filterModal.modal('show');
      self.mobile_modal(true);
    }
  };

  self.toggleOverflowModal = function() {
    if(self.mobile_modal()){
      self.$overflowModal.modal('hide');
      self.mobile_modal(false);
    } else {
      self.$overflowModal.modal('show');
      self.mobile_modal(true);
    }
  };

  self.showSortModal = function() {
    self.$overflowModal.modal('hide');
    self.$sortOptionsModal.modal('show');
  };

  self.showFilterTypeModal = function() {
    self.$overflowModal.modal('hide');
    self.$filterTypesModal.modal('show');
  };

  self.searchChanged = function() {
    self.resetDropdowns();
    var selected_resources = [];
    self.resourceSearch.get(self.searchQuery(), function (suggestions) {
      _.each(suggestions, function (item) {
        selected_resources.push(item);
      });
    });
    if(_.isEmpty(selected_resources)){
      self.updateResourceData(self.allResources());
      self.searchApplied(false);
    } else {
      self.updateResourceData(selected_resources);
      self.searchApplied(true);
    }
  };

  self.filterChanged = function() {
    if(!_.isUndefined(self.selectedFilter()) && self.selectedFilter().type){
      var filtered_resources = [];
      // TODO: possibly refactor this later
      _.each(self.allResources(), function (res) {
        _.each(res.all_resourcings, function(item){
          if(self.selectedFilter().number){
            if((item.type == self.selectedFilter().type) && (item.number == self.selectedFilter().number)){
              filtered_resources.push(res);
            }
          } else {
            if(item.type == self.selectedFilter().type){
              filtered_resources.push(res);
            }
          }
        });
      });
      self.updateResourceData(filtered_resources);
    } else {
      self.updateResourceData(self.allResources());
    }
  };

  self.typeChanged = function() {
    if(_.isEmpty(self.selectedType())){
      self.updateResourceData(self.allResources());
    } else {
      var filtered_resources = _.where(self.allResources(), { type: self.selectedType() } );
      self.updateResourceData(filtered_resources);
    }
  };

  self.toggleSortDirection = function() {
    if(self.selectedSortDir() == 'desc'){
      self.selectedSortDir('asc');
    } else {
      self.selectedSortDir('desc');
    }
    self.stateChanged('', 'Sort');
  };

  // TODO: Move this into UI util for a generic 'front end sorting'
  // then update table.js
  self.sortChanged = function() {
    var sorted = [];
    if(!_.isUndefined(self.selectedSort())){
      sorted = _.sortBy(self.resources(), self.selectedSort().param);
      sorted = (self.selectedSortDir() === 'desc') ? sorted.reverse() : sorted;
      self.updateResourceData(sorted);
    } else {
      self.updateResourceData(self.allResources());
    }
  };

  self.resetDropdowns = function(){
    //self.searchQuery('');
    //self.selectedFilter('View All');
    //self.selectedSort('');
  };

  self.resetSearch = function(){
    self.searchQuery('');
    self.searchApplied(false);
    self.toggleSearch();
    self.updateResourceData(self.allResources());
  };

  self.forceGridView = function(){
    if((self.windowWidth() < self.mobileBreakPoint) && self.table_view()){
      self.grid_view(true);
      self.table_view(false);
    }
  };

  self.hideResourceInfoModal = function() {
    var $resourceInfoModal = $('#resource_info_modal');
    $resourceInfoModal.modal('hide');
  };

  self.updateUserState = function(resource) {
    const request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.user_states_path(),
      data: { user_state: { stateable_id: resource.id, stateable_type: 'Resource', data: JSON.stringify({last_viewed_at: moment().format(Kadenze.I18n.t('date.formats.default'))}) }}
    });
  };

  self.showResourceInfoModal = function(res) {
    if (_.isObject(res.blocked_modal)) {
      new Kadenze.Notice.info(res.blocked_modal);
      return false;
    }
    var $resourceInfoModal = $('#resource_info_modal');
    res['showResourceShareModal'] = self.showResourceShareModal;
    var vm = ko.dataFor($resourceInfoModal[0]);
    vm.selectedResource(res);
    $resourceInfoModal.modal('show');
    self.updateUserState(vm.selectedResource());
  };

  self.showResourceShareModal = function (item, event) {
    if (_.isObject(item.blocked_modal)) {
      new Kadenze.Notice.info(item.blocked_modal);
      return false;
    }
    self.hideResourceInfoModal();
    var params = { modal_title: 'Share this resource',
      shareableObj: { title: 'Kadenze',
        description: 'Kadenze brings together educators, artists, and engineers from leading universities to provide world-class education in the fields of art and creative technology.',
        course_id: item.course_id,
        id: item.id,
        share_url: item.path },
      emailShareCb: self.shareResource };
    var modal = new Kadenze.ShareModal(params);
    modal.show();
  };

  self.shareResource = function(item, emails) {
    console.log('sharing: ' + emails);
    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.share_course_resource_path(item.course_id, item.id),
      data: {emails: emails}
    });

    request.done(function(res) {
      console.log('shared!');
    });

    request.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.message;
      }
      new Kadenze.Notice.error({message: msg});
    });
  };

  self.updateFiltersFromUrl = function() {
    var query = Kadenze.Util.getURLParams(location.search);
    var keys = _.keys(query);
    var found = _.filter(self.acceptedURLParams(), function(param){ return _.include(keys, param); });
    if(window.location.search !== '' && !_.isEmpty(found)){
      if (typeof query.q !== 'undefined' && !_.isEmpty(query.q)) {
        self.searchQuery(query.q);
        self.searchApplied(true);
        self.toggleSearch();
        if(self.windowWidth() < self.mobileBreakPoint){
          self.$mobileSearchEl.val(query.q);
        } else {
          self.$searchEl.val(query.q);
        }
      }

      if (typeof query.filter !== 'undefined' && !_.isEmpty(query.filter)){
        var obj = {};
        var q = s.capitalize(query.filter);
        if (typeof query.number !== 'undefined' && !_.isNaN(parseInt(query.number))){
          obj = { type: q, number: query.number };
        } else {
          obj = { type: q };
        }
        self.selectedFilter(obj);
      }

      if (typeof query.sort !== 'undefined' && !_.isNaN(parseInt(query.sort))){
        var matched = _.find(self.sortItems(), function(sort_item){ return sort_item.id == query.sort; });
        if(!_.isEmpty(matched)) {
          self.selectedSort(matched);
        }
      }

      if (typeof query.id !== 'undefined' && !_.isNaN(parseInt(query.id))){
        var found_resource = _.find(self.allResources(), function(r) { return r.id == query.id; });
        self.showResourceInfoModal(found_resource);
      }
    }
  };

  self.$window.resize(function(){
    self.windowWidth(self.$window.width());
  });

  self.searchQuery.subscribe(function(value){
    self.stateChanged(value, 'Search');
  });

  self.selectedFilter.subscribeChanged(function(newValue, oldValue){
    if(!_.isUndefined(newValue)){
      self.stateChanged(newValue, 'Filter');
    } else {
      self.stateChanged(oldValue, 'Filter');
    }
  });

  self.selectedFilterText = ko.computed(function() {
    if (_.isEmpty(self.selectedFilter())){
      return 'All Resources';
    } else if(!_.isEmpty(self.selectedFilter().name)){
      return s.prune(self.selectedFilter().name, 30);
    } else if (!_.isEmpty(self.selectedFilter().type)) {
      return 'General';
    }
  });

  self.selectedType.subscribe(function(value){
    self.stateChanged(value, 'Type');
  });

  self.selectedSort.subscribe(function(value){
    self.stateChanged('', 'Sort');
  });

  self.table_view.subscribe(function(value) {
    if(value) {
      self.selectedSortDir('asc');
      self.selectedSort(self.sortItems()[0]);
    }
  });

  const __construct = function(that) {
    console.log('constructor called for StudentResourceIndexViewModel');
    Kadenze.UIUtil.showLoadingIndicator();
    that.bindData(data);
    if(that.windowWidth() < that.mobileBreakPoint){
      that.initMobileNav();
      self.initSearchEvents(self.$mobileSearchEl);
      self.initTypeahead(self.$mobileSearchEl);
      //that.forceGridView();
    } else {
      self.initSearchEvents(self.$searchEl);
      self.initTypeahead(self.$searchEl);
    }
  }(this);
}
